export class ContextualSafetyApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Require an identity recheck for a subject (carries the deciding reason code + model version). */
    requireRecheck(input) {
        return this.client.request({ method: 'POST', path: '/v1/contextual-safety/rechecks', body: input, auth: true });
    }
    /** Resolve a recheck PASSED (`passed: true`) or FAILED — refused (409) if it is no longer REQUIRED. */
    resolveRecheck(recheckId, passed) {
        return this.client.request({ method: 'POST', path: `/v1/contextual-safety/rechecks/${encodeURIComponent(recheckId)}/resolve`, body: { passed }, auth: true });
    }
    /** Read a recheck (with its current store revision). */
    getRecheck(recheckId) {
        return this.client.request({ method: 'GET', path: `/v1/contextual-safety/rechecks/${encodeURIComponent(recheckId)}`, auth: true });
    }
    /** Raise a safety flag on a subject (carries the deciding reason code + model version). */
    raiseFlag(input) {
        return this.client.request({ method: 'POST', path: '/v1/contextual-safety/flags', body: input, auth: true });
    }
    /** Clear a flag as a false positive — audited who/when/reason; refused (409) if it is not ACTIVE. */
    /** Clear a flag as a false positive; the signed-in operator is recorded as who cleared it (D397). */
    clearFlag(flagId, reason) {
        return this.client.request({ method: 'POST', path: `/v1/contextual-safety/flags/${encodeURIComponent(flagId)}/clear`, body: { reason }, auth: true });
    }
    /** List a subject's flags (newest first). */
    listFlags(subjectId) {
        return this.client.request({ method: 'GET', path: `/v1/contextual-safety/flags?subjectId=${encodeURIComponent(subjectId)}`, auth: true });
    }
    /** Evaluate a ride safety context into triggered checks and persist the immutable evaluation. */
    evaluateTriggers(input) {
        return this.client.request({ method: 'POST', path: '/v1/contextual-safety/triggered-checks', body: input, auth: true });
    }
    /** List a ride's triggered-check evaluations (newest first). */
    listTriggeredChecks(rideId) {
        return this.client.request({ method: 'GET', path: `/v1/contextual-safety/triggered-checks?rideId=${encodeURIComponent(rideId)}`, auth: true });
    }
}
//# sourceMappingURL=contextual-safety.js.map